import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

//Material imports
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
const useStyles = makeStyles(theme => ({
  container: {
    gridTemplateAreas: `"stroke" 
                            "text"
                            `,
    display: "grid",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 32,
    marginBottom: "1%"
  },
  strokeContent: {
    gridArea: "stroke",
    width: 52,
    height: 2,
    backgroundColor: "#408290",
    margin: "auto"
  },
  titleContent: {
    gridArea: "text",
    marginTop: 24
  },
  [theme.breakpoints.up("sm")]: {
    strokeContent: {
      width: 64,
      marginRight: 18
    },
    container: {
      display: "inline-grid",
      gridTemplateAreas: `"stroke text"
                                `,
      textAlign: "left",
      marginTop: "4%"
    },
    titleContent: {
      marginTop: 0
    }
  },
  [theme.breakpoints.up("md")]: {
    strokeContent: {
      width: 70
    }
  }
}));

// SSR-safe location hook
const useSafeLocation = () => {
  try {
    return useLocation();
  } catch (e) {
    return {
      pathname: '',
      search: '',
      hash: '',
      state: null,
      key: 'default'
    };
  }
};
const SectionHeader = ({
  header,
  extraHeaderStyle = ""
}) => {
  const classes = useStyles();
  const location = useSafeLocation();
  const isOnboardingDetail = location.pathname === "/onboarding/detail";
  return /*#__PURE__*/React.createElement(Grid, {
    className: `${classes.container} ${extraHeaderStyle}`
  }, !isOnboardingDetail && /*#__PURE__*/React.createElement(Grid, {
    className: classes.strokeContent
  }), /*#__PURE__*/React.createElement(Typography, {
    className: classes.titleContent,
    variant: "h5",
    color: "textPrimary"
  }, header));
};
SectionHeader.propTypes = {
  header: PropTypes.string.isRequired,
  extraHeaderStyle: PropTypes.string
};
export default SectionHeader;